var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CurrencyInput',_vm._b({staticClass:"demo__currency-input form-control",attrs:{"value":_vm.value,"auto-decimal-mode":true,"distraction-free":false,"currency":_vm.currency,"locale":"pt-BR"},on:{"input":_vm.onInput}},'CurrencyInput',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }